import React from 'react'
import { Breakpoint } from 'react-socks'

export default ({ children }) => (
  <Breakpoint tabletLow up>
    {children}
  </Breakpoint>
)
